module.exports = __webpack_public_path__ + "img/师资培训红色对钩.c837deee.jpg";